/** @jsx jsx */
import { jsx } from 'theme-ui';
import styled from '@emotion/styled';
import theme from '../../gatsby-plugin-theme-ui-v1';

const Container = styled.div`
  position: fixed;
  top: 70px;
  z-index: 1000;
  width: 100%;

  a {
    color: #ffffff;
    background: #094f6e;
    display: block;
    font-size: 1em;
    font-family: ${theme.fonts.nav};
    font-weight: 500;
    padding: 12px 16px 8px;
    text-align: center;
    text-decoration: none;

    &:after {
      background: hsla(0, 0%, 100%, 0.4);
      border-radius: 1em;
      content: '\\2192';
      display: inline-block;
      height: 28px;
      margin-left: 8px;
      width: 28px;
    }
  }

  .bannerCode {
    border: 2px solid #fff;
    border-radius: 4px;
    font-weight: 700;
    letter-spacing: .5px;
    padding: 0 0.2em;
    text-transform: uppercase;
    font-size: .8em;
  }


`;

const WelcomeBanner = ({ brand, urlParams, url }) => {
  // Harry's always has name. Optional to have offer + code.
  return  <Container id="welcomeBanner" >  
  <a className="harrys" href={url}>Welcome to Harry's 
    {urlParams.name &&
        <span>, {urlParams.name}</span>}
    !
    {urlParams.offer && urlParams.code && 
      <span>
        &nbsp;Enter code <span className="bannerCode">{urlParams.code}</span> at checkout for {urlParams.offer}.
      </span>
    }
  </a>
  </Container>
};

export default WelcomeBanner;
